import { RootState } from '../index';
import { Participant, StoreStatus } from '../../core/types/common.types';

export const errorSelector = (state: RootState): any | null => state.participant.errors || null;

export const isBusySelector = (state: RootState): boolean => state.participant.status === StoreStatus.BUSY;

export const responseSelector = (state: RootState): Participant | null => state.participant.response || null;

export const hasSuccessSelector = (state: RootState): boolean => (state.participant.response ? true : false);
